<template>

  <div>
    <PageHeader title="Define Micro Notes">

      <div class="pull-right">
        <a v-if="chapter && microNotable()" v-on:click.prevent="toggleReplaceWarning" href class="btn btn-primary btn-lg" style="float:right;margin-left:10px;">
          <i class="fas fa-save"></i> &nbsp; Save changes
        </a>

        <a v-else-if="chapter" href class="btn btn-primary btn-lg disabled" disabled style="float:right;margin-left:10px;">
          <i class="fas fa-save"></i> &nbsp; Save changes
        </a>

        <router-link :to="{name: 'subject-shelf'}" class="btn btn-danger btn-lg" style="float:right;margin-left:10px;">
          <i class="fas fa-arrow-left"></i> &nbsp; Cancel
        </router-link>


        <div class="text-right pull-right xs-mt-5 xs-mb-10">
          <KeywordSettings v-if="chapter" :chapterId="chapter.chapter_id" />
        </div>
      </div>
      <div class="pull-left">
        <Help>
          <div slot="content">
            Split your lecture notes into micro notes with the <span class="btn btn-default"><span class="fa fa-minus"></span></span> button. Select keywords to be hidden/tested with the <span class="btn btn-default"><span class="fa fa-key"></span></span> button.<br />
            Click an image and select <span class="btn btn-default"><span class="fa fa-object-group"></span></span> to convert the image to a micro note. Image keywords can be set in the next stage.<br />
          </div>
        </Help>
      </div>

      <div class="clearfix"></div>
    </PageHeader>

    <div class="main-content container-fluid xs-pt-0">
      <div class="row height-100">
        <div class="col-md-12 height-100">
          <div class="height-100-minus" v-if="chapter">
            <div v-if="showReplaceWarning" class="bg-danger clearfix">
              <p class="pull-left">
                <b>Warning:</b> You've created {{ microNotes.length }} micro notes based on this chapter. Those micro notes will be replaced. Are you sure you want to proceed?
              </p>
              <div class="pull-right">
                <a v-on:click.prevent="replaceMicroNotes" href class="btn btn-default btn-sm" style="float: right">
                  Replace
                </a>
                <a v-on:click.prevent="toggleReplaceWarning" href class="btn btn-default btn-sm btn-margin" style="float: right">
                  Cancel
                </a>
              </div>
            </div>
            <FroalaEditor ref="editor" v-if="!saving" :chapterId="chapter.id" :config="froalaConfig" v-model="html" />
            <LoadingIndicator text="Saving..." v-else></LoadingIndicator>
            <p class="text-muted">{{statusMessage}}</p>
          </div>
          <div v-else>
            <LoadingIndicator />
          </div>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div>


</template>


<script>
import _ from 'underscore'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import froalaConfig from '../froala-editor/config/lecture-note-editor.js'
import moment from 'moment'
import FroalaEditor from '../froala-editor/FroalaEditor'
import router from '../../router'
  import KeywordSettings from '../micro-note-editor/KeywordSettings'
  import LoadingIndicator from '../shared/LoadingIndicator'


export default {
  components: {
    FroalaEditor,
    KeywordSettings,
    LoadingIndicator
    },
    

    created() {
      this.getChapters();
      this.getMicroNotes();
    },

    methods: {
      ...mapActions(['getMicroNotes', 'getChapters']),

      saveMicroNotes(deleteOld) {
        this.status = 'saving';
        const splitHtml = this.html.split('<hr is="divider">');
        const currentMicroNotes = this.microNotes;

        var processed = 0;
        if (splitHtml.length > 0) {
          this.saving = true;
          this.toggleReplaceWarning();

          for (let i = 0; i < splitHtml.length; i++) {
            this.$store.dispatch('createMicroNote', {
              microNote: {
                chapter_id: this.chapter.id,
                html: splitHtml[i],
                micro_note_type: 'html'
              },
              callback: (err) => {
                // #todo - error
                this.status = 'saved';
                processed += 1;

                if (processed === splitHtml.length) {
                  if (deleteOld) {
                    this.deleteMicroNotes(currentMicroNotes);
                  } else {
                    this.saving = false;
                    this.redirect();
                  }
                }
              },
            });
          }
        }
      },

      deleteMicroNotes(microNotes) {
        this.microNotesToDelete = microNotes
        this.deleteNextMicroNote();
      },
      deleteNextMicroNote() {
        if (this.microNotesToDelete.length > 0) {
          const m = Object.assign({}, this.microNotesToDelete[0]);
          if (this.microNotesToDelete.length > 1) {
            this.$store.dispatch('deleteMicroNote', { micronote: m, callback: this.deleteNextMicroNote });
          } else {
            this.$store.dispatch('deleteMicroNote', { micronote: m, callback: this.redirect });
          }

          this.microNotesToDelete.shift();
        } else {
          this.saving = false;
          this.redirect();
        }
      },
      redirect() {
        Toast.success('Micro Notes updated');
        router.push({ name: 'subject-shelf' });
      },
    
    toggleReplaceWarning() {
      this.showReplaceWarning = !this.showReplaceWarning;
      },

    replaceMicroNotes() {
      if (this.microNotable()) {
        this.saveMicroNotes(true);
      }
    },

      microNotable() { // looks to see that there is content besides html tags in editor, and that there is at least one <hr> element
        if (this.html) {
          return (this.html.replace('/<[^>]*>/', '') != '' && this.html.match(/<hr is="divider"\/?>/) != null)
        } else {
          return false;
        }
    }
  },

    computed: {
      chapter() {
        return this.$store.state.chapters[this.$route.params.chapterId];
      },

      microNotes() {
        const chapterId = parseInt(this.$route.params.chapterId);
        if (!chapterId) return [];
        const allMicroNotes = this.$store.getters.allMicroNotes;
        const microNotes = _.where(allMicroNotes, { chapter_id: chapterId, micro_note_type: 'html' });
        
        return microNotes;
      },

    statusMessage() {
      if (!this.chapter) return '';
      if(this.status === 'saving') {
        return 'Saving...';
      } else if(this.status === 'saved') {
        return 'Changes saved.';
      } else {
        return `Last saved ${moment(this.chapter.updated_at).fromNow()}`;
      }
      },

      newMicroNoteCount() {
        return this.html.split('<hr is="divider">').length;
      }
  },

  data () {
    return {
      html: '',
      froalaConfig: Object.assign({}, froalaConfig, {
        height: 'calc(100% - 55px)',
      }),
      showReplaceWarning: false,
      status: null, // saving status
      microNotesToDelete: [],
      saving: false,
    }
  },

  watch: {
    // When we change microNotes, reset this.newHtml
    microNotes(newMicroNotes, oldMicroNotes) {
      if (newMicroNotes && newMicroNotes.length > 0) {
        let html = '';
        const length = newMicroNotes.length;

        for (let i = 0; i < newMicroNotes.length; i++) {
          let microNote = newMicroNotes[i];
          html += microNote.html;
          if (i < (length - 1)) { html += '<hr is="divider">'; }
        }
        this.html = html;
      } else {
        this.html = '';
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .height-100 {
    height: 100%;
  }

  .height-100-minus {
    height: calc(100vh - 240px); /* minus height of panel heading and save btn*/
  }

  .home-link {color:#444444;font-size:14px;}

  .btn-margin { margin-right: 10px; }

  .bg-danger {
    color: #FFFFFF;
    padding: 15px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// MicroNoteCreator.vue?1e419518